<footer class="tc-footer-st4" *ngIf="(data | async)?.restaurant_data">
  <div class="footer-links">
      <div class="container">
          <div class="row justify-content-between">
              <div class="col-lg-4 pe-lg-5">
                  <div class="foot-info">
                      <div class="logo mb-20">
                          <img class="th-70" [defaultImage]="'./assets/images/placeholder.jpg'" [lazyLoad]="(data | async)?.restaurant_data?.logo" 
                          alt="{{(data | async)?.restaurant_data?.logo_alt_text ? (data | async)?.restaurant_data?.logo_alt_text : (data | async)?.restaurant_data?.restaurant_name}}" />
                      </div>
                      <div class="text fsz-18" style="font-weight: 300 !important;" *ngIf="about_content"> {{about_content}} </div>
                      <div class="social-links" *ngIf="(data | async)?.restaurant_data?.social_media && (data | async)?.restaurant_data?.social_media?.length > 0">
                        <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" 
                        href="{{item?.link}}" target="_blank" title="{{item.media_name}}" class="btn {{item.media_name}}">
                          <img src="assets/icons/{{item.media_name}}.svg" alt="{{item.media_name}}">
                        </a>  
                      </div>
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="links-group">
                      <h6 class="fsz-20 mb-4 mt-5 mt-lg-0"> Opening Hours </h6>
                      <ul class="links opening-closing">
                        <ng-container *ngIf="footerScheduleRaw?.length > 0">
                            <li class="today">
                              <span class="day-name"><strong>Today</strong></span> 
                              <div class="block-elem">
                                    <span class="today-time" *ngFor="let schedule of getFooterTodayScheduleItems()"><strong>{{ schedule }}</strong></span>
                              </div>
                            </li>
                        </ng-container>
                        
                        <div (click)="showScheduleClick()" class="more-schedule d-flex align-items-center justify-content-between mb-2" data-toggle="collapse" href="#multiCollapseExample1"
                          role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <span class="">Show {{isShowScheduleClick ? 'less' : 'all'}}</span>
                            <span class="icon {{isShowScheduleClick ? 'icon-up' : ''}} ">
                              <i class="flaticon-arrow-down-sign-to-navigate" ></i>
                            </span>
                        </div>

                        <div class="collapse multi-collapse {{ isScreenLg ? 'show' : '' }} {{isShowScheduleClick ? 'collapse-show' : ''}}" id="multiCollapseExample1">
                          <div class="">
                            <ng-container *ngFor="let day of footerSchedule">
                              <li class="schedules">
                                <ng-container>
                                  <span class="day">{{day.dayName}}</span>
                                  <span class="time">
                                    <ng-container *ngIf="day?.status === 'open' && (day.shift?.length > 0 || day?.label); else showClosed">
                                      <ng-container *ngIf="day?.label; else showShiftTimes">
                                        <li *ngFor="let label of getFooterScheduleLabelItems(day.label)">
                                          <span class="text-lowercase">{{label}}</span>
                                        </li>
                                      </ng-container>
                                      <ng-template #showShiftTimes>
                                        <li *ngFor="let time of day.shift">
                                          <span class="text-lowercase">{{time.openingTime}} - {{time.closingTime}}</span>
                                        </li>
                                      </ng-template>
                                    </ng-container>
                                    <ng-template #showClosed>
                                      <span>Closed</span>
                                    </ng-template>
                                  </span>
                                </ng-container>
                              </li>
                            </ng-container>
                          </div>
                        </div>
                      </ul>
                  </div>
              </div>
              <div class="col-lg-2 ps-lg-5">
                  <div class="links-group">
                      <h6 class="fsz-20 mb-4 mt-5 mt-lg-0"> Quick Links </h6>
                      <ul class="links">
                        <li *ngIf="(user | async)?.isLogged === true">
                          <a class="link" title="My Account" [routerLink]="['/my-account']" routerLinkActive="active">My Accounts</a>
                        </li>
                        <li *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active">
                          <a class="link" title="Order" [routerLink]="['/order-online']">Order</a>
                        </li>
                        <li *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
                          <a class="link" title="Reservation" [routerLink]="['/reservation']">Reservation</a>
                        </li>
                        <li *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
                          <a class="link" title="Deals" [routerLink]="['/deals']">Deals</a>
                        </li>
                        <li *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
                          <a class="link" title="Review" [routerLink]="['/reviews']">Review</a>
                        </li>
                        <li><a class="link" title="Terms & conditions" [routerLink]="['/terms-conditions']">Terms & Conditions</a></li>
                        <li><a class="link" title="Privacy policy" [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
                      </ul>
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="links-group">
                      <h6 class="fsz-20 mb-4 mt-5 mt-lg-0"> Contact </h6>
                      <ul class="links contact-info">
                          <li class="address">  <a href="{{(data | async)?.restaurant_data?.map_url ? (data | async)?.restaurant_data?.map_url : 'https://www.google.com/maps/search/'+restaurant_address}}"  target="_blank" title="{{restaurant_address_for_view}}">{{restaurant_address_for_view}}</a> </li>
                          <li class="email" *ngIf="(data | async)?.restaurant_data?.email || (data | async)?.restaurant_data?.reservationRecipientEmail || (data | async)?.restaurant_data?.orderRecipientEmail"> 
                              <a class="d-block" href="mailto:{{(data | async)?.restaurant_data?.email}}" title="{{(data | async)?.restaurant_data?.email}}">{{(data | async)?.restaurant_data?.email}}</a>
                              <a class="d-block" href="mailto:{{(data | async)?.restaurant_data?.reservationRecipientEmail}}" title="{{(data | async)?.restaurant_data?.reservationRecipientEmail}}">{{(data | async)?.restaurant_data?.reservationRecipientEmail}}</a>
                              <a class="d-block" href="mailto:{{(data | async)?.restaurant_data?.orderRecipientEmail}}" title="{{(data | async)?.restaurant_data?.orderRecipientEmail}}">{{(data | async)?.restaurant_data?.orderRecipientEmail}}</a>
                          </li>
                          <li class="phone mb-0" *ngIf="(data | async)?.restaurant_data?.business_tel && (data | async)?.restaurant_data?.business_tel !==''">
                            <ng-container *ngFor="let item of (data | async)?.restaurant_data?.business_tel | split">
                              <a href="tel:{{item.trim()}}" title="{{item.trim()}}"><span>{{item.trim()}}</span></a><br>
                            </ng-container>
                          </li>
                      </ul>
                  </div>
                  <hr style="border-top: 1px solid #ddd">

                  <div class="links-group mt-4 mb-4" *ngIf="(data | async)?.restaurant_data?.is_delivery && areas?.length > 0">
                    <h6 class="fsz-20 mb-4 mt-5 mt-lg-0"> Delivery Areas </h6>
                    <ul>
                      <li class="areas" *ngFor="let item of areas | slice:0:2;">
                        <ng-container *ngIf="item?.is_radius">
                          <span *ngIf="item?.delivery_charge === 0">Free Delivery</span>
                          <span *ngIf="item?.delivery_charge > 0">Delivery Charge {{item.delivery_charge |  CustomCurrency}}</span>
                          : Up-to {{item?.maximum_delivery_area}} mile radius
                        </ng-container>
                        <ng-container *ngIf="item?.is_radius === false">
                          {{item?.area_name.toUpperCase()}} {{item?.area_postcode.toUpperCase()}} -
                          <span *ngIf="item?.delivery_charge > 0"> Delivery Charge {{item?.delivery_charge |  CustomCurrency}}</span>
                          <span *ngIf="item?.delivery_charge === 0"> Free Delivery</span>
                        </ng-container>
                      </li>
                    </ul>
                    
                    <a *ngIf="areas?.length >= 3" type="button" class="site-primary-btn site-primary-btn-dark sm-btn mt-3" data-toggle="modal" data-target="#deliveryAreas">
                      See More 
                      <img src="assets/img/arrow-right-1.png" alt="arrow-right">
                    </a>
                </div>
              </div>
          </div>
      </div>
  </div>
  <div class="container">
      <div class="foot">
          <p class="fsz-16">
            <span class="mainColor">  Copyright ©{{today | date: 'yyyy'}}<strong>&nbsp;<a routerLink="/" title="{{(data | async)?.restaurant_data?.restaurant_name}}">{{(data | async)?.restaurant_data?.restaurant_name}}</a>
            </strong>. All Rights Reserved </span> </p>
      </div>
  </div>
  <div class="lines"><span></span><span></span><span></span><span></span></div>
</footer>


<div class="modal fade" id="deliveryAreas" tabindex="-1" role="dialog" aria-labelledby="deliveryAreasTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable sliding-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deliveryAreasTitle">Delivery Areas</h5>
        <button type="button" class="btn btn-sm btn-outline-danger rounded-circle" data-dismiss="modal">
          <span class="icon"><i class="flaticon-unchecked" ></i></span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="list-group list-group-flush">
          <li class="list-group-item px-0" *ngFor="let item of areas">
            <span *ngIf="item?.is_radius">
              <span *ngIf="item?.delivery_charge === 0">Free Delivery</span>
              <span *ngIf="item?.delivery_charge > 0">
                Delivery Charge <b>{{item.delivery_charge |  CustomCurrency}}</b>
              </span>
              : Up-to {{item?.maximum_delivery_area}} mile radius
            </span>
            <span *ngIf="item?.is_radius === false">
              {{item?.area_name.toUpperCase()}} {{item?.area_postcode.toUpperCase()}} -
              <span *ngIf="item?.delivery_charge > 0"> Delivery Charge <b>{{item?.delivery_charge |  CustomCurrency}}</b></span>
              <span *ngIf="item?.delivery_charge === 0"> Free Delivery</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
